import {
  Action,
  CircularGaugeChart, FontWeight, HStack, Icon, ICON_BULLSEYE_ARROW, ICON_CHART_LINE, Message, Stack, Text,
} from '@doveit/bricks';
import React from 'react';
import Markdown from 'react-markdown';
import { GoalMetric, IndividualGoal, TimeRange } from '../../../providers/api/dtos';
import {
  configByRating
  ,
} from './mapper';
import { getPerformanceDetails } from './utils/getPerformanceDetails';
import EditAgentGoalAction from '../../containers/edit-agent-goal-action/EditAgentGoalAction';
import { PerformanceActionType } from './utils/getPerformanceAction';

export interface GoalPerformanceDetailViewProps {
  metric: GoalMetric,
  timeRange: TimeRange,
  goal: IndividualGoal,
  onNewGoalAccepted?: (goal: IndividualGoal) => void,
}

/**
 * @todo rename to `IndividualGoalPerformanceDetailView`
 */
const GoalPerformanceDetailView: React.FC<GoalPerformanceDetailViewProps> = ({
  metric,
  timeRange,
  goal,
  onNewGoalAccepted,
}) => {
  const {
    title, status, message, performanceDescription, progress, targetDescription, action,
  } = React.useMemo(() => getPerformanceDetails(metric, goal, timeRange), [goal, metric, timeRange]);
  const { color, hint } = configByRating[status];

  return (
    <Stack gap={200}>
      <HStack gap={300}>
        <CircularGaugeChart
          progress={progress}
          size="L"
          color={hint.messageType}
        />
        <Text.H4 fontWeight={500} color={color}>
          {title}
        </Text.H4>
      </HStack>

      <HStack gap={300}>
        <Icon
          path={ICON_CHART_LINE}
          size={40}
          color="neutral.default.highest"
        />
        <Text.Body fontWeight={FontWeight.LIGHT}>
          <Markdown components={{ p: ({ _node, ...props }) => props.children }}>
            {performanceDescription}
          </Markdown>
        </Text.Body>
      </HStack>

      {targetDescription && (
        <HStack gap={300} wrap="nowrap">
          <Icon
            path={ICON_BULLSEYE_ARROW}
            size={40}
            color="neutral.default.highest"
          />
          <Text.Body fontWeight={FontWeight.LIGHT}>
            <Markdown components={{ p: ({ _node, ...props }) => props.children }}>
              {targetDescription}
            </Markdown>
          </Text.Body>
        </HStack>
      )}

      <Message
        type={message.type}
        message={message.title}
        icon={hint.icon}
      >
        {message.description}
      </Message>

      {action?.type === PerformanceActionType.EDIT_TARGET && (
        <div>
          <EditAgentGoalAction
            agentId={goal.agentId}
            onGoalAccepted={onNewGoalAccepted}
          >
            {({ openEditModal }) => (
              <Action
                label={action.label}
                color={action.color}
                size="S"
                emphasis="high"
                onClick={openEditModal}
                aria-label="Pulsante per modificare l'obiettivo di guadagno"
              />
            )}
          </EditAgentGoalAction>
        </div>
      )}
    </Stack>
  );
};

export default GoalPerformanceDetailView;
